"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var TrackingContext_1 = require("../TrackingContext");
var useTrackEvent = function (eventName, eventProperties) {
    if (eventProperties === void 0) { eventProperties = {}; }
    var trackEvent = TrackingContext_1.useTrackingContext().trackEvent;
    react_1.useEffect(function () {
        trackEvent(eventName, eventProperties);
        /**
         * Can't just pass `eventProperties` into the dependency array here because
         * it's a new object each time (even if the values are the same), so this hook
         * will get called on every re-render.
         *
         * A deep compare of `eventProperties` is an option, but Dan Abramov says that
         * deep compares are generally a bad idea here, which is why `useEffect` doesn't
         * just do that itself. He suggests using `JSON.stringify` instead, as long as the
         * object is only a couple layers deep.
         *
         * https://twitter.com/dan_abramov/status/1104414272753487872
         */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventName, JSON.stringify(eventProperties)]);
};
exports.default = useTrackEvent;
